module.exports = __webpack_public_path__ + "media/img/home/directions/list-1-b4fda15390183c193f43e4aad079d85b.svg";